import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-selected-file',
    templateUrl: './selected-file.component.html',
})
export class SelectedFileComponent {
    public delete: OutputEmitterRef<number> = output<number>();
    public readonly file: InputSignal<File> = input.required<File>();
    public readonly index: InputSignal<number> = input.required<number>();

    public deleteFile(): void {
        this.delete.emit(this.index());
    }
}
